import React from 'react'
import { ThemeProvider } from 'styled-components'
import { render, RenderResult } from '@testing-library/react'
import zuto from '@zuto/theme/src/zuto'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'

// This should match your app's custom theme
const theme = createTheme({
  customComponents: {
    progressBar: {
      bar: {
        backgroundColor: '#eee',
        height: '8px',
        borderRadius: '4px'
      },
      progress: {
        backgroundColor: '#0070f3',
        height: '100%',
        borderRadius: '4px'
      }
    }
  },
  customPalette: tonalPalettes
})

const renderWithTheme = (children: React.ReactElement): RenderResult => render(
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={zuto}>
      {children}
    </ThemeProvider>
  </MuiThemeProvider>
)

export default renderWithTheme
